import React from 'react';
import { ThemeProvider } from '../context/ThemeContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import ThankYouSection from '../components/sections/ThankYouSection';
import ScrollToTop from '../components/ui/ScrollToTop';

const ThankYouPage: React.FC = () => {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[var(--color-background)] text-[var(--color-text)]">
        <Header />
        <main>
          <ThankYouSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </ThemeProvider>
  );
};

export default ThankYouPage;
